import React from 'react';
import ClientForm from "../../components/Admin/ClientForm/ClientForm";

const ClientFormPage = () => {
  return <ClientForm />;
};

export default ClientFormPage;
